import { Component, OnInit, Output, EventEmitter, Input, inject, Inject } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { SharedService } from 'app/modules/common/services/shared-service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TemplateService } from '../../services/template.service';
import { FileService } from 'app/modules/common/services/file.service';
import { CommonTemplateService } from '../../services/common-template.service';
import { PlantillaTemplate } from 'app/modules/common/entities/plantilla-template.model';
import { FileFormatEnum } from 'app/modules/common/enums/file-format-enum';

/**
 * Add template dialog data
 */
export interface AddTemplateDialogData {
    controller: string;
}

@Component({
    selector: 'app-add-comtemplate',
    templateUrl: './add-template.component.html',
    styleUrls: ['./add-template.component.scss'],
    standalone: false
})
export class AddTemplateComponent implements OnInit {

    @Input() IsUpdate = false;
    @Input() Template: PlantillaTemplate = null;
    @Input() TemplateFile = null;

    public templateTitle = 'Nuevo Plantilla';

    templateFormGroup: UntypedFormGroup;
    IsSaving = false;

    public FileFormatEnum = FileFormatEnum;

    /**
     * This event is fired when a template is saved to the database
     */
    @Output() saved: EventEmitter<void> = new EventEmitter();


    constructor(
        public fb: UntypedFormBuilder,
        private sharedService: SharedService,
        public dialogRef: MatDialogRef<AddTemplateComponent>,
        private templateService: CommonTemplateService,
        private fileService: FileService,
        @Inject(MAT_DIALOG_DATA) private dialogData: AddTemplateDialogData,
    ) { }

    ngOnInit(): void {
        this.initForm();
        if (this.IsUpdate) {
            this.templateTitle = 'Editar plantilla';
        }
    }


    /**
     * Initialize form
     */
    private initForm(): void {
        const uploadPath = 'Plantillas\\Citaciones';
        let id = 0;
        let name = '';
        let document = null;

        if (this.IsUpdate) {
            id = this.Template.plantillaId;
            name = this.Template.nombre;
            document = this.TemplateFile;
        }

        this.templateFormGroup = this.fb.group({
            'plantillaId': [id],
            'nombre': [name, Validators.required],
            'path': [uploadPath, Validators.required],
            'documentInBase64': [document, Validators.required]
        });
    }


    /**
     * Add document to database or update the existing one
     */
    public addDocument(): void {
        // mark feilds as touched
        this.templateFormGroup.get('nombre').markAsTouched();
        this.templateFormGroup.get('path').markAsTouched();
        this.templateFormGroup.get('documentInBase64').markAsTouched();        

        // get template ID
        let id = 0; // when we pass template ID 0, server creates a new record for this template
        if (this.Template !== null) {
            id = this.Template.plantillaId;
        }
                
        const fileType = this.templateFormGroup.get('nombre').value;
        const extension = fileType.split('.').pop()

        if (!FileFormatEnum.CitationController.includes(extension)) {
            this.sharedService.ShowSnackBar('Formato de fichero no permitido: ' + extension.ToString(), '', 2500);
            return;
        }

        if (this.templateFormGroup.valid) {

            this.IsSaving = true;

            // create template model
            const model = this.templateFormGroup.value;
            model.plantillaId = id;

            // save template
            this.templateService.saveNewTemplate(this.dialogData.controller, model)
                .subscribe(resp => {
                    this.IsSaving = false;
                    this.sharedService.ShowSnackBar('Guardado con éxito', '', 2500);
                    this.templateFormGroup.reset();
                    this.saved.emit();
                    this.dialogRef.close();
                }, () => {
                    this.IsSaving = false;
                    console.error('no se puede guardar');
                });
        }
    }


    /**
     * Handle upload file click
     * @param event Event
     */
    uploadFile(event: any[]): void {
        this.readFile(event[0]);
    }


    private readFile(file: any): void {
        const fileReader = new FileReader();
        fileReader.onload = () => {
            const name = file.name;
            const inputName = this.templateFormGroup.get('nombre').value;
            if (inputName === '' || inputName === undefined || inputName === null) {
                this.templateFormGroup.get('nombre').patchValue(name);
            }

            this.templateFormGroup.get('documentInBase64').patchValue(this.fileService.arrayBufferToBase64(fileReader.result));
        };

        //if (this.fileService.getFileExtention(file.type) === 'DOC') {
        if (FileFormatEnum.LOPDControllerTS.includes(this.fileService.getFileExtention(file.type))) {
            fileReader.readAsArrayBuffer(file);
        }
        else {
            this.sharedService.ShowSnackBar('No se puede aceptar este tipo de archivo', 'Okay', 1500);
        }
    }


    /**
     * Close dialog
     */
    public cancel(): void {
        this.dialogRef.close();
    }

}
